"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "nameAtVersion", {
    enumerable: true,
    get: function() {
        return nameAtVersion;
    }
});
function nameAtVersion(name, version) {
    return `${name}@${version}`;
}
